export default {
	editSelected: 'Edit selected',
	label: 'Mass edit',
	warning: 'NB! This action will overwrite all selected connections.',
	warningRules: 'NB! This action will overwrite all rule statuses of selected measures.',
}
